import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Utility } from '../../../common/utility';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';
import { DialogService } from '../../../shared/services/dialog.service';
import { ManagePriceListService } from './manage-price-list.service';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { PriceListModel } from '../../../models/centre/price.model';
import { CurrencyNumberDirective } from '../../../directives/currency-number.directive';
import { CurrencyNumberPipe } from '../../../pipes/currency-number.pipe';
import { ValidationService } from '../../../shared/services/validation.service';

@Component({
    selector: 'edit-price-popup',
    templateUrl: 'edit-price-popup.component.html',
    providers: [ManagePriceListService, CurrencyNumberPipe, CurrencyNumberDirective]
})

export class EditPricePopUpComponent implements OnInit {
    public isSuccess = false;
    public editPriceForm: FormGroup;
    public itemPriceModel =  new PriceListModel();
    public priceModel: any;
    public currencyObj = {
        code: '',
        id: '',
        symbol: '',
        symbolPosition: 'L',
        rate: 1
    };
    constructor(private formBuilder: FormBuilder,
        public managePriceListService: ManagePriceListService,
        public dialogRef: MdDialogRef<EditPricePopUpComponent>,
        public dialogService: DialogService,
        public utility: Utility,
        public currencyPipe: CurrencyNumberPipe,
        @Inject(MD_DIALOG_DATA) public data: any) {
        this.createForm();
    }

    ngOnInit() {
      //this.itemPriceModel = this.managePriceListService.getPriceItemDetail(this.data.id);
      this.itemPriceModel.item = this.data.name;
      this.itemPriceModel.categoryName = this.data.categoryName;
      this.currencyObj = this.data.listCurencies.find(c => c.code === this.data.currencyCode);
    }

    createForm() {
        this.editPriceForm = this.formBuilder.group({
            centreName: [this.data.centreName],
            centreId: [this.data.centreId],
            categoryName: [this.data.productCategoryName],
            itemId: [''],
            name: [''],
            modelId: [this.data.modelId],
            costPrice: [this.data.costPrice, [Validators.required, this.isValidCurrencyRange]],
            defaultPrice: [this.data.defaultPrice, [Validators.required, this.isValidCurrencyRange]],
            clinicPrice: [this.data.clinicPrice, [Validators.required, this.isValidCurrencyRange]],
            taxPrice: [this.data.taxPrice * 100, [Validators.required, this.isValidPercent]],
            consultationFeeId: [null]
        });
    }

    isValidCurrencyRange(control: AbstractControl) {
      if (+control.value < 0 || +control.value > 10000) {
        return { 'invalidDecimalRange/0/10000': true };
      }
      return null;
    }

    isValidPercent(control: AbstractControl) {
      if (+control.value < 0 || +control.value > 100) {
        return { 'invalidRange/0/100': true };
      }
      return null;
    }

    onCloseDialog() {
        this.dialogRef.close(this.isSuccess);
    }

    /**
     * Convert number for directive appCurrencyNumber
     * @param control
     */
    convertString(control: AbstractControl) {
      let value = control.value;
      if (typeof value === 'string' && value.includes('.')) {
        if (value.split('.')[1].length === 3 ) {
          value = value.slice(0, -1);
        }
      }
      control.setValue(value.toString());
    }

    onSubmit() {
      if (this.editPriceForm.valid) {
        // this.convertString(this.editPriceForm.controls['costPrice']);
        // this.convertString(this.editPriceForm.controls['defaultPrice']);
        this.convertString(this.editPriceForm.controls['clinicPrice']);
       // this.convertString(this.editPriceForm.controls['taxPrice']);
       const price = ((this.editPriceForm.controls['taxPrice'].value) / 100).toString();
        if (this.data.modelId !== 'Consultations') {
            this.editPriceForm.controls['itemId'].setValue(this.data.id);
            this.editPriceForm.controls['name'].setValue(this.data.name);
            this.editPriceForm.controls['consultationFeeId'].setValue(0);
            this.editPriceForm.controls['taxPrice'].setValue(price);
            this.managePriceListService.updatePrice(this.data.id, this.editPriceForm.value).subscribe(
                result => {
                    if (result) {
                        const data = result.json();
                        this.dialogService.openSuccessDialog({message : data.message});
                        this.isSuccess = true;
                        this.onCloseDialog();
                    }
                }
            );

        } else {
          this.editPriceForm.controls['itemId'].setValue(this.data.id);
          this.editPriceForm.controls['name'].setValue(this.data.name);
          this.editPriceForm.controls['taxPrice'].setValue(price);
          this.editPriceForm.controls['consultationFeeId'].setValue(this.data.consultationfeeId);
          this.managePriceListService.updatePriceConsultation(this.data.consultationfeeId, this.editPriceForm.value).subscribe(
            result => {
              if (result) {
                const data = result.json();
                this.dialogService.openSuccessDialog({
                  message: data.message
                });
                this.isSuccess = true;
                this.onCloseDialog();
              }
            }
          );
        }
      }
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-price/edit-price-popup.component.ts